import { SessionAction } from '../actions/sessions'

const initialState: Props = {
  urlName: '',
  id: 0,
  isError: false,
  isAuthenticated: false,
  isProcessing: false,
  admin: false,
  isFetching: true,
}

interface Props {
  urlName: string
  id: number
  isError: boolean
  isAuthenticated: boolean
  isProcessing: boolean
  admin: boolean
  isFetching: boolean
}

const reducer = (state: Props = initialState, action: SessionAction): Props => {
  switch (action.type) {
    default: {
      return {
        ...state,
      }
    }
  }
}

export default reducer
